import { render, staticRenderFns } from "./XuCountryCode.vue?vue&type=template&id=c4edadda&scoped=true"
import script from "./XuCountryCode.vue?vue&type=script&lang=js"
export * from "./XuCountryCode.vue?vue&type=script&lang=js"
import style0 from "./XuCountryCode.vue?vue&type=style&index=0&id=c4edadda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4edadda",
  null
  
)

export default component.exports